module.exports = __webpack_public_path__ + "static/media/new-serena-icon.5432ebde.png";